import { rem, radius, spacing, token } from '@thiememeulenhoff/lit-sdk';
import { css, CSSResult, unsafeCSS } from 'lit';
import {
  ContentMessageType,
  ContentMessageTypes,
} from '@thiememeulenhoff/types';
import { tagName } from '../../helpers';

export const tag = tagName('content-message');

const contentMessageTypeStyle = (contentMessageType: ContentMessageType) => {
  const selector = unsafeCSS(`[type=${contentMessageType}]`);
  const iconClass = unsafeCSS(`.content-message-icon-${contentMessageType}`);
  const borderToken = {
    info: 'content-message-info-border-default',
    message: 'content-message-accent-border-default',
    refresh: 'content-message-accent-border-default',
  }[contentMessageType];
  const foregroundToken = {
    info: 'status-info-foreground',
    message: 'content-message-accent-foreground-default',
    refresh: 'content-message-accent-foreground-default',
  }[contentMessageType];

  return css`
    :host(${selector}) {
      border-color: ${token(borderToken)};
      a-icon {
        color: ${token(foregroundToken)};
      }
      .header {
        font-weight: bold;
      }
    }

    ${iconClass} {
      color: ${token(foregroundToken)};
    }
  `;
};

const styles: Array<CSSResult> = [];

styles.push(css`
  :host {
    background: ${token('background-tertiary')};
    border-radius: ${radius('medium')};
    box-sizing: border-box;
    color: ${token('text-primary')};
    display: flex;
    flex-direction: column;
    gap: ${spacing(50)};
    inline-size: 100%;
    padding: ${spacing(150)};
  }

  .header-container {
    align-items: center;
    display: flex;
    gap: ${spacing(100)};
  }

  .time-information {
    color: ${token('text-secondary')};
    display: block;
    font-size: ${rem(14)};
    margin-block-end: ${spacing(100)};
  }

  .content-message {
    border-inline-start: ${rem(2)} solid;
    color: ${token('text-primary')};
    margin-inline-start: ${spacing(50)};
    padding-inline-start: ${spacing(100)};
  }
`);

ContentMessageTypes.forEach((type: ContentMessageType) =>
  styles.push(contentMessageTypeStyle(type)),
);

export const contentMessageStyles = styles;
